import { AxiosError, AxiosResponse } from 'axios';
import {
    SPRAY_SUBMISSION_SUBMIT_FAILED,
    SPRAY_SUBMISSION_SUBMIT_REQUESTED,
    SPRAY_SUBMISSION_SUBMIT_SUCCEEDED,
    SPRAY_SUBMISSION_LOAD_CANCELED,
    SPRAY_SUBMISSION_LOAD_FAILED,
    SPRAY_SUBMISSION_LOAD_REQUESTED,
    SPRAY_SUBMISSION_LOAD_SUCCEEDED,
    SPRAY_SUBMISSION_SET
} from './constants';
import {
    RequestedSubmitSubmissionAction,
    SucceededSubmitSubmissionAction,
    FailedSubmitSubmissionAction,
    SpraySubmissionProduct,
    SpraySubmissionProductId,
    SetSpraySubmissionAction,
    RequestLoadSpraySubmissionAction,
    SucceededLoadSpraySubmissionAction,
    FailedLoadSpraySubmissionAction,
    CanceledLoadSpraySubmissionAction
} from './types';

export function setSpraySubmission(spraySubmission: Record<SpraySubmissionProductId, SpraySubmissionProduct>): SetSpraySubmissionAction {
    return {
        type: SPRAY_SUBMISSION_SET,
        payload: spraySubmission
    }
}

export function requestedSubmitSpraySubmission(payload: SpraySubmissionProductId): RequestedSubmitSubmissionAction {
    return {
        type: SPRAY_SUBMISSION_SUBMIT_REQUESTED,
        payload
    };
}

export function succeededSubmitSpraySubmission(): SucceededSubmitSubmissionAction {
    return {
        type: SPRAY_SUBMISSION_SUBMIT_SUCCEEDED
    };
}

export function failedSubmitSpraySubmission(
    error: AxiosError
): FailedSubmitSubmissionAction {
    return {
        type: SPRAY_SUBMISSION_SUBMIT_FAILED,
        payload: error,
        error: true
    };
}

export function requestLoadSpraySubmission(spraySubmissionId: SpraySubmissionProductId): RequestLoadSpraySubmissionAction {
    return {
        type: SPRAY_SUBMISSION_LOAD_REQUESTED,
        payload: spraySubmissionId
    };
}

export function succeededLoadSpraySubmission(
    response: AxiosResponse
): SucceededLoadSpraySubmissionAction {
    return {
        type: SPRAY_SUBMISSION_LOAD_SUCCEEDED,
        payload: response
    };
}

export function failedLoadSpraySubmission(
    error: AxiosError
): FailedLoadSpraySubmissionAction {
    return {
        type: SPRAY_SUBMISSION_LOAD_FAILED,
        payload: error,
        error: true
    };
}

export function canceledLoadSpraySubmission(): CanceledLoadSpraySubmissionAction {
    return {
        type: SPRAY_SUBMISSION_LOAD_CANCELED
    };
}
